import styled from 'styled-components'
import tw from 'twin.macro'

const Container = styled.div`
  ${tw`w-full cursor-pointer px-5`}
`

const Title = styled.h2`
  ${tw`font-semibold leading-h4 mb-3`}
  color: black;
  font-size: 18px;
  max-height: 48px;
  /* the workaround for text-overflow: ellipsis; only works in 1 line text */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

const PublisherContainer = styled.div`
  margin-bottom: 20px;
  a {
    ${tw`flex`}
  }
  img {
    ${tw`rounded-full`}
    width: 20px;
    height: 20px;
  }
  .photo-container {
    ${tw`mr-2`}
  }
  .user-name {
    ${tw`text-h6-d`}
    color: black;
  }
`

const ArticleImageContainer = styled.div`
  ${tw`mb-3`}
  img {
    ${tw`rounded-1 object-cover`}
  }
`

const ArticleImage = styled.div`
  position: relative;
  img {
    ${tw`w-full h-full absolute top-0 bottom-0 right-0 left-0`}
  }
`

export { Container, Title, PublisherContainer, ArticleImageContainer, ArticleImage }
